import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '../../lib/utils';

// shadcn/ui Popover (Radix). Positioning is Floating UI under the hood: it
// re-measures on every resize, scroll and size change, flips to the other
// side when there's no room, slides along to stay `collisionPadding` px
// inside the window, and renders in a portal so no card or scroll box can
// clip it. Escape, click-outside and focus return come with it.
// (Nic 2026-10-25: our hand-placed pickers drifted off the page on resize.)
// hideWhenDetached (Nic 2026-10-26): once its field scrolls out of its
// scroll box (under a Workspace's bottom bar), the popover hides with it
// instead of floating over the bar; it's back when the field scrolls back.

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef(
  (
    {
      className,
      align = 'end',
      sideOffset = 8,
      collisionPadding = 8,
      hideWhenDetached = true,
      ...props
    },
    ref,
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        hideWhenDetached={hideWhenDetached}
        className={cn(
          // Never taller or wider than the room Radix measured, so it can't
          // spill past the window even on a tiny screen; scroll inside.
          'z-[1200] max-h-[var(--radix-popover-content-available-height)] max-w-[var(--radix-popover-content-available-width)] overflow-y-auto rounded-xl bg-white p-3 shadow-[0_4px_20px_rgba(15,23,42,0.15)] outline-none ring-1 ring-slate-200/80 dark:!bg-surface-elevated dark:ring-white/10',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  ),
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent };
